import React, { useContext } from "react";
import { Form, Input, Select } from "antd";
import { context } from "../../context/context";

const AdsFormStepOne = () => {
    const [form] = Form.useForm();
    // context
    const {
        selectedAdId,
        adNumOfSlide,
        setAdNumOfSlide,
        adPosition,
        setAdPosition,
        adPriority,
        setAdPriority,
        adLimit,
        setAdLimit,
    } = useContext(context);
    // functions
    const handleChangePriority = (value) => {
        setAdPriority(value);
    };
    const handleChangePosition = (value) => {
        setAdPosition(value);
    };
    const handleChangeNumOfSlide = (value) => {
        setAdNumOfSlide(value);
    };
    const handleChangeLimit = (e) => {
        setAdLimit(e.target.value);
    };
    return (
        <div
            style={{
                direction: "rtl",
                display: "flex",
                gap: "15px",
                margin: "15px",
            }}
        >
            <Form
                layout="vertical"
                form={form}
                name="control-hooks"
                style={{
                    width: "100%",
                }}
            >
                <div style={{ display: "flex", gap: "2rem" }}>
                    <Form.Item
                        name="priority"
                        label="اولویت"
                        style={{ width: "100%" }}
                    >
                        <Select
                            style={{
                                width: "100%",
                            }}
                            defaultValue={selectedAdId ? adPriority : []}
                            onChange={handleChangePriority}
                            tokenSeparators={[","]}
                            options={[
                                { value: 1, label: "1" },
                                { value: 2, label: "2" },
                                { value: 3, label: "3" },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        name="position"
                        label="موقعیت"
                        style={{ width: "100%" }}
                    >
                        <Select
                            style={{
                                width: "100%",
                            }}
                            defaultValue={selectedAdId ? adPosition : []}
                            onChange={handleChangePosition}
                            tokenSeparators={[","]}
                            options={[
                                { value: "home", label: "خانه" },
                                { value: "list", label: "لیست نتایج" },
                                { value: "detail", label: "جزئیات" },
                                { value: "comment", label: "نظرات" },
                                { value: "sendComment", label: "ثبت نظر" },
                                {
                                    value: "profileLikes",
                                    label: "لایک شده های پروفایل",
                                },
                                {
                                    value: "profileBookmarks",
                                    label: "علاقه مندی های پروفایل",
                                },
                            ]}
                        />
                    </Form.Item>
                </div>
                <div style={{ display: "flex", gap: "2rem" }}>
                    <Form.Item
                        name="limit"
                        label="تعداد کاربران"
                        style={{ width: "100%" }}
                    >
                        <Input
                            type="number"
                            defaultValue={selectedAdId ? adLimit : null}
                            onChange={handleChangeLimit}
                        />
                    </Form.Item>
                    <Form.Item
                        name="numOfSlide"
                        label="ترتیب اسلاید"
                        style={{ width: "100%" }}
                    >
                        <Select
                            style={{
                                width: "100%",
                            }}
                            defaultValue={selectedAdId ? adNumOfSlide : []}
                            onChange={handleChangeNumOfSlide}
                            tokenSeparators={[","]}
                            options={[
                                { value: 1, label: "1" },
                                { value: 2, label: "2" },
                                { value: 3, label: "3" },
                                { value: 4, label: "4" },
                                { value: 5, label: "5" },
                                { value: 6, label: "6" },
                                { value: 7, label: "7" },
                            ]}
                        />
                    </Form.Item>
                </div>
            </Form>
        </div>
    );
};

export default AdsFormStepOne;
